import {
    RESERVE_PRODUCE_CANCEL_REQUEST,
    RESERVE_PRODUCE_CANCEL_SUCCESS,
    RESERVE_PRODUCE_CANCEL_ERROR,
    RESERVE_PRODUCE_CANCEL_CONFIRMATION_OPEN,
    RESERVE_PRODUCE_CANCEL_CONFIRMATION_CLOSE,
} from 'state/actions/reserve_produce_cancel'

const initialState = {
    submitting: false,
    errorMessage: '',
    confirmationOpened: false,
}

export default function(state = initialState, action = {}) {
    switch (action.type) {
    case RESERVE_PRODUCE_CANCEL_REQUEST: {
        return {
            ...state,
            submitting: true,
            errorMessage: '',
            confirmationOpened: false,
        }
    }
    case RESERVE_PRODUCE_CANCEL_SUCCESS: {
        return {
            ...state,
            submitting: false,
        }
    }
    case RESERVE_PRODUCE_CANCEL_ERROR: {
        const { errorMessage } = action.payload
        return {
            ...state,
            submitting: false,
            errorMessage,
        }
    }
    case RESERVE_PRODUCE_CANCEL_CONFIRMATION_OPEN: {
        return {
            ...state,
            confirmationOpened: true,
        }
    }
    case RESERVE_PRODUCE_CANCEL_CONFIRMATION_CLOSE: {
        return {
            ...state,
            confirmationOpened: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/reserve_produce_cancel.js